import { useState } from "react";
import type { ChoiceProps } from "./Choice";
import Choice from "./Choice";
import FieldError from "./FieldError";
import FormFieldWrapper from "./FormFieldWrapper";
import Label from "./Label";

type ChoiceItemProps = Omit<
  ChoiceProps,
  "name" | "selected" | "value" | "fullWidth"
> & {
  value: string;
};

type ChoiceGroupProps = {
  name: string;
  label?: string;
  defaultValue?: string;
  error?: string;
  choices: Array<ChoiceItemProps>;
  required?: boolean;
};

function UncontrolledChoiceGroup({
  name,
  error,
  choices,
  defaultValue,
  label,
  required,
}: ChoiceGroupProps) {
  const [value, setValue] = useState<string | undefined>(defaultValue);

  return (
    <FormFieldWrapper fullWidth>
      <Label id={name} label={label} required={required} />
      <div
        className="gap-2 w-full grid"
        style={{ gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))" }}
      >
        {choices.map((choiceProps) => (
          <Choice
            {...choiceProps}
            key={choiceProps.value}
            name={name}
            selected={choiceProps.value === value}
            onSelect={(ev) => setValue(ev.target.value)}
          />
        ))}
      </div>
      <FieldError error={error} />
    </FormFieldWrapper>
  );
}

const ChoiceGroup = UncontrolledChoiceGroup;

export default ChoiceGroup;
